import { Component, Injector, OnInit, ElementRef } from '@angular/core';
import { TextAutoCompleteComponent } from '../text-autocomplete/text-autocomplete.component';
import { ApplicationService } from '../../../../services/application/application.service';
import { AutocompleteOption } from '../../../../../js/interfaces/CoverpathTypes';
import { RXList } from './RXList';

@Component({
  moduleId: module.id,
  selector: 'text-autocomplete-rx',
  host: {
    '(document:click)': 'handleClick($event)',
  },
  templateUrl: '../text-autocomplete/text-autocomplete.component.html',
})
export class TextAutoCompleteRXComponent extends TextAutoCompleteComponent implements OnInit {
  private rxList: AutocompleteOption[] = [];

  constructor(protected injector: Injector, protected appService: ApplicationService, myElement: ElementRef) {
    super(injector, appService, myElement);
    this.rxList = RXList.sort().map(
      (name: string): AutocompleteOption => ({
        fieldValue: name,
        listValue: name,
      })
    );
  }

  protected setOptions() {
    this.options = this.rxList;
  }
}
